(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['app/feature-config/FeatureConfigModel', 'services/userFeatureConfigService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var userFeatureConfigService = require('./../urls').userFeatureConfigService;
    module.exports = factory(require('./../feature-config/FeatureConfigModel'), userFeatureConfigService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (FeatureConfigModel, userFeatureConfigService) {
  'use strict';

  /**
   * Model for user configuration information. Uses the UserFeatureConfigService and corresponds to a UserFeatureConfig
   *
   * @class UserFeatureConfigModel
   * @extends FeatureConfigModel
   * @constructor
   */
  return new (FeatureConfigModel.extend({
    urlRoot: userFeatureConfigService
  }))();
}));
